/* NuevArt commerce - pure helpers, no dependencies or network access. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.NuevartCommerceCore = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var normalize = function (value) { return String(value == null ? '' : value).trim().toLowerCase(); };
  function tags(product) {
    var value = product && product.tags;
    return (Array.isArray(value) ? value : String(value || '').split(',')).map(normalize).filter(Boolean);
  }
  function meaningfulTags(products, config) {
    var ignored = new Set(String(config.ignoreTags || '').split(',').map(normalize));
    var excluded = normalize(config.excludeTag);
    var prefix = normalize(config.priorityPrefix);
    var counts = new Map();
    products.forEach(function (product) {
      tags(product).forEach(function (tag) {
        if (ignored.has(tag) || tag === excluded || tag.length < 3 || /^(\d+x\d+|\d+to\d+)$/.test(tag)) return;
        counts.set(tag, (counts.get(tag) || 0) + 1);
      });
    });
    return Array.from(counts.keys()).sort(function (a, b) {
      var ap = prefix && a.startsWith(prefix) ? 100 : 0;
      var bp = prefix && b.startsWith(prefix) ? 100 : 0;
      return (bp + counts.get(b)) - (ap + counts.get(a)) || a.localeCompare(b);
    });
  }
  function rankCandidates(candidates, seeds, excludedIds, config) {
    var excluded = new Set(excludedIds.map(String));
    seeds.forEach(function (p) { excluded.add(String(p.id)); });
    var seedTags = new Set(meaningfulTags(seeds, config));
    var priority = normalize(config.priorityPrefix);
    var manual = new Map((config.manualProducts || []).map(function (p, i) { return [String(p.id), 10000 - i]; }));
    var seen = new Set();
    return candidates.filter(function (p) {
      if (!p || p.id == null || p.available !== true || p.gift_card === true || !p.handle) return false;
      if (/^gift[ -]?cards?$/i.test(p.type || '')) return false;
      if (excluded.has(String(p.id)) || seen.has(String(p.id))) return false;
      if (config.excludeTag && tags(p).includes(normalize(config.excludeTag))) return false;
      seen.add(String(p.id));
      return true;
    }).map(function (p, index) {
      var score = manual.get(String(p.id)) || 0;
      tags(p).forEach(function (tag) {
        if (seedTags.has(tag)) score += priority && tag.startsWith(priority) ? 40 : 4;
      });
      return { product: p, score: score, index: index };
    }).sort(function (a, b) { return b.score - a.score || a.index - b.index; })
      .slice(0, Math.max(2, Math.min(8, Number(config.limit) || 6)))
      .map(function (row) { return row.product; });
  }
  function rewardState(quantity, cap) {
    var q = Math.max(0, Math.floor(Number(quantity) || 0));
    var max = Math.max(1, Math.min(6, Math.floor(Number(cap) || 2)));
    var sets = Math.min(max, Math.floor(q / 3));
    return {
      quantity: q, sets: sets, cap: max,
      maximum: max * 3, progress: Math.min(100, q / (max * 3) * 100),
      needed: sets >= max ? 0 : (sets + 1) * 3 - q
    };
  }
  function searchQuery(selectedTags) {
    return selectedTags.slice(0, 3).map(function (tag) {
      return 'tag:"' + String(tag).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
    }).join(' OR ');
  }
  function codeStatus(cart, code) {
    var match = (cart.discount_codes || []).find(function (d) { return normalize(d.code) === normalize(code); });
    if (match && match.applicable === true) return 'applied';
    if (match && match.applicable === false) return 'rejected';
    var apps = (cart.cart_level_discount_applications || []).slice();
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) { apps.push(a.discount_application || {}); });
    });
    if (apps.some(function (a) { return a.type === 'discount_code' && normalize(a.title) === normalize(code); })) return 'applied';
    return 'pending'; // Shipping or customer eligibility may only be known at checkout.
  }
  return { normalize: normalize, tags: tags, meaningfulTags: meaningfulTags, rankCandidates: rankCandidates, rewardState: rewardState, searchQuery: searchQuery, codeStatus: codeStatus };
});
